/* Inspections selectors. */
import { LOADING, SUCCEEDED } from '@constants/fetchStatuses'

export const selectTaxProfilesSlice = state => state.taxProfiles

export const selectCreateTaxProfile = state => selectTaxProfilesSlice(state).createTaxProfile
export const selectCreateTaxProfileStatus = state => selectCreateTaxProfile(state).status
export const selectIsCreateTaxProfileLoading = state => {
  return selectCreateTaxProfileStatus(state) === LOADING
}
export const selectCreateTaxProfileError = state => selectCreateTaxProfile(state).error

export const selectUpdateTaxProfile = state => selectTaxProfilesSlice(state).updateTaxProfile
export const selectUpdateTaxProfileStatus = state => selectUpdateTaxProfile(state).status
export const selectIsUpdateTaxProfileLoading = state => {
  return selectUpdateTaxProfileStatus(state) === LOADING
}
export const selectUpdateTaxProfileError = state => selectUpdateTaxProfile(state).error

export const selectTaxProfiles = state => selectTaxProfilesSlice(state).taxProfiles
export const selectTaxProfilesData = state => {
  const taxProfiles = selectTaxProfiles(state).data
  const sortedTaxProfiles = [...taxProfiles].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
  return sortedTaxProfiles
}
export const selectTaxProfilesStatus = state => selectTaxProfiles(state).status
export const selectIsTaxProfilesLoading = state => selectTaxProfilesStatus(state) === LOADING
export const selectIsTaxProfilesSucceeded = state => selectTaxProfilesStatus(state) === SUCCEEDED
export const selectTaxProfilesError = state => selectTaxProfiles(state).error

export const selectW9File = state => selectTaxProfilesSlice(state).w9File
export const selectW9FileUrl = state => selectW9File(state).data.url
export const selectW9FileStatus = state => selectW9File(state).status
